export default (
  input: Record<string, string> = {},
  ignoreKeys: string[] = []
) => Object.keys(input).some(key => !input[key] && !ignoreKeys.includes(key))
